import React from 'react';
import {GET_ALL_TENANTS} from '../../consts/queries';
import {executeBackendQuery} from "../../requests/executeBackendQuery";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";

class SelectMultiTenantFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            index: false,
        };
    }

    componentDidMount() {
        executeBackendQuery({
            queryName: GET_ALL_TENANTS,
            params: {}
        }).then(res => {
            const index = {};
            const seenNames = new Set();
            const filteredUniqueTenants = [];
            
        res.data.forEach(item => {
            index[item.ARCIMEDES_ROW_ID] = item;

            const key = item.NAME && item.NAME.trim().toLowerCase();
            if (!seenNames.has(key)) {
                seenNames.add(key);
                filteredUniqueTenants.push(item);
            }
        });

            this.setState({
                items: filteredUniqueTenants,
                index,
            });
        });
    }

    render() {
        const { items } = this.state;
        const { theme, value, valueKey, label, disabled, data, isFilter, handleParentChange} = this.props;

        return (
            <Dropdown theme={theme}
                      dropdownType='multiple'
                      optionsType='tenant'
                      optionKey='ARCIMEDES_ROW_ID'
                      optionLabelKey='NAME'
                      options={items}
                      value={value}
                      valueKey={valueKey}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      handleParentChange={handleParentChange}
            />
        );
    }
}

SelectMultiTenantFilter.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
};

export default SelectMultiTenantFilter;
